export default __webpack_public_path__ + "static/scores@992_2x-b0e937681cc461ec558c37f8940fc699.webp";